import { RavIcon } from '@shared/icon/icon';
import { RowAction, TableAction } from '../table/actions/action';

export interface TableConfig {
  columns: TableColumn[];
  mobileSettings?: {
    /**
     * If the table has rename enabled, make sure element 0 is
     * always the one to be renamed. To ensure a better UX, if
     * the row is renameable, it is preferable to add only one
     * string to the titleKeys list.
     */
    titleKeys: string[];
    subtitleKey: string;
    subtitleHeader: string;
    subtitleAdditionalInfo?: string;
    icon?: RavIcon | ((row: any) => string);
    preventFixedPaginator?: boolean;
  };
  actions?: TableAction[];
  isSearchable?: boolean;
  searchLabel?: string;
  fixedPageSize?: number;
  dataType?: TableDataType;
  rowLaunchLink?: string | ((row: any) => string);
  canDragRows?: boolean;
  /**
   * Set to true whenever you are loading a secondary table so
   * that primary and secondary tables have no conflicts setting
   * and getting url params.
   */
  preventUrlParamHandling?: boolean;
}

export interface TableColumn {
  key: string;
  header?: string;
  sortBy?: string;
  link?: string | ((row: any) => string);
  icon?: RavIcon | ((row: any) => string);
  action?: RowAction;
  additionalInfo?: string;
  tooltip?: string | ((row: any) => string);
}

export enum TableDataType {
  Account = 'account',
  Document = 'document',
  Filesystem = 'filesystem',
  Folder = 'folder',
  Scanner = 'scanner',
  User = 'user'
}

export interface TableSearch {
  field: string;
  value: string;
}
export interface TableSort {
  key: string;
  asc: boolean;
}

export interface GlobalSearch extends TableSearch {
  criteria?: GlobalSearchCriteria | string;
  modifier?: GlobalSearchModifier;
  fromDate?: string;
  toDate?: string;
}

export enum GlobalSearchCriteria {
  Contains = 'partial',
  Range = 'range',
  GreaterThan = '>',
  LessThan = '<',
  Equals = '='
}

export enum GlobalSearchModifier {
  And = 'and',
  Or = 'or'
}
